import React, { useState } from "react";
import styles from "./UsersSyncErrorsTab.module.css";
import InfoCard from "DreamStream/Shared/InfoCard";
import SearchBar from "DreamStream/Shared/SearchBar";
import Card from "shared/Card";
import ConfirmationModal from "DreamStream/Shared/ConfirmationModal";
import SyncErrorsList from "./SyncErrorsList";

const errorList = [
  {
    name: "Peter and Rachel",
    iboNum: "0000000010",
    syncError: "Not Found",
    date: "MM/DD/YYY",
    time: "12:00 AM",
    status: true,
  },
  {
    name: "Ana Marie Smith",
    iboNum: "0000000011",
    syncError: "Not Found",
    date: "MM/DD/YYY",
    time: "12:00 AM",
    status: true,
  },
  {
    name: "First and Last Name",
    iboNum: "0000000012",
    syncError: "Not Found",
    date: "MM/DD/YYY",
    time: "12:00 AM",
    status: true,
  },
  {
    name: "First and Last Name",
    iboNum: "0000000013",
    syncError: "Not Found",
    date: "MM/DD/YYY",
    time: "12:00 AM",
    status: true,
  },
  {
    name: "Last Name",
    iboNum: "0000000014",
    syncError: "Not Found",
    date: "MM/DD/YYY",
    time: "12:00 AM",
    status: true,
  },
  {
    name: "Last Name",
    iboNum: "0000000014",
    syncError: "Not Found",
    date: "MM/DD/YYY",
    time: "12:00 AM",
    status: true,
  },
  {
    name: "First and Last Name",
    iboNum: "0000000016",
    syncError: "Not Found",
    date: "MM/DD/YYY",
    time: "12:00 AM",
    status: true,
  },
  {
    name: "First Name",
    iboNum: "0000000000",
    syncError: "Not Found",
    date: "MM/DD/YYY",
    time: "12:00 AM",
    status: true,
  },
  {
    name: "First Name",
    iboNum: "0000000000",
    syncError: "Not Found",
    date: "MM/DD/YYY",
    time: "12:00 AM",
    status: true,
  },
  {
    name: "First and Last Name",
    iboNum: "0000000000",
    syncError: "Not Found",
    date: "MM/DD/YYY",
    time: "12:00 AM",
    status: true,
  },
  {
    name: "First and Last Name",
    iboNum: "0000000000",
    syncError: "Not Found",
    date: "MM/DD/YYY",
    time: "12:00 AM",
    status: true,
  },
  {
    name: "First and Last Name",
    iboNum: "0000000000",
    syncError: "Not Found",
    date: "MM/DD/YYY",
    time: "12:00 AM",
    status: true,
  },
  {
    name: "First and Last Name",
    iboNum: "0000000000",
    syncError: "Not Found",
    date: "MM/DD/YYY",
    time: "12:00 AM",
    status: true,
  },
  {
    name: "First and Last Name",
    iboNum: "0000000000",
    syncError: "Not Found",
    date: "MM/DD/YYY",
    time: "12:00 AM",
    status: true,
  },
];

/**
 * Content in users sync errors page.
 */

export function UsersSyncErrorsTab() {
  const [runSyncModalOpen, setRunSyncModalOpen] = useState(false);
  const [repairSyncModalOpen, setRepairSyncModalOpen] = useState(false);
  const [searchInput, setSearchInput] = useState("");

  //Temporary filtering
  const keys = ["iboNum", "name"];

  const search = (data) => {
    return data.filter((item) =>
      keys.some((key) => item[key].toLowerCase().includes(searchInput))
    );
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.infoCardContainer}>
          <InfoCard
            body="24"
            btnName="REPAIR"
            footer="IBOs Not Found"
            header="ERRORS"
            onClick={() => {
              setRepairSyncModalOpen(true);
            }}
          />

          <InfoCard
            body="10/18/2022 12:01 AM"
            btnName="SYNC"
            footer="Next Sync: 11/18/2022 12:01 AM"
            header="TIME OF LAST GLOBAL SYNC"
            onClick={() => {
              setRunSyncModalOpen(true);
            }}
          />
        </div>

        <Card className={styles.cardContainer}>
          <div className={styles.cardHeader}>
            <h5 className={styles.title}>IBO SYNC ERRORS</h5>
            <div className={styles.hr} />
          </div>
          <div className={styles.searchBarDiv}>
            <div className={styles.searchBar}>
              <SearchBar
                searchDelay={0}
                minChar={0}
                btn={true}
                onInput={(value) => setSearchInput(value)}
                placeholderText="Search "
              />
            </div>
          </div>
          <div className={styles.usersDiv}>
            <SyncErrorsList errors={search(errorList)} />
          </div>
        </Card>

        <ConfirmationModal
          header="REPAIR MISSING PLUGINS"
          isOpen={repairSyncModalOpen}
          description="Attempt to fix [#] of Error IBO Not Found."
          btnName="REPAIR"
          onClose={() => setRepairSyncModalOpen(false)}
          onClick={() => alert("Repair Sync clicked")}
        />

        <ConfirmationModal
          header="RUN GLOBAL SYNC"
          isOpen={runSyncModalOpen}
          description="Sync every user in the Dreamstream database. The last global sync was run [MM/DD/YYYY at HH:MM AM]."
          btnName="RUN SYNC"
          onClose={() => setRunSyncModalOpen(false)}
          onClick={() => alert("Run Sync clicked")}
        />
      </div>
    </>
  );
}
